import { DictionaryContext } from 'application/adapters/context/Dictionary';
import classNames from 'classnames';
import React, { useContext, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button, Form, FormfieldString, LoginBox, Paragraph } from 'ui/components';
import styles from './CreateAccount.module.scss';
// import fieldStyles from 'ui/components/2-molecules/Form/FormfieldString/FormfieldString.module.scss';

interface FormData {
	password: string;
	confirmPassword: string;
}

export interface CreateAccountProps {
	className?: string;
	heading?: string;
	text?: string;
	name?: string;
	email?: string;
}

export const CreateAccount: React.FC<CreateAccountProps> = ({
	// className,
	heading,
	text,
	name,
	email,
}) => {
	const dictionary = useContext(DictionaryContext);

	// FORM HANDLING
	// const [allErrors, setallErrors] = useState(0);
	const [errorSummary, setErrorSummary] = useState(0);
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm<FormData>({ mode: 'onBlur' });

	const onSubmit: SubmitHandler<FormData> = (data) => {
		alert(`${dictionary.getValue('Authentication.ThanksForSubmitting', null, 'Thanks for submitting')} ${JSON.stringify(data)}`);
	};

	const onError = (data) => {
		const totalErrors = Object.keys(data).length;
		setErrorSummary(totalErrors);
		// setallErrors(data);
	};
	// / FORM HANDLING

	return (
		<LoginBox heading={heading}>
			{text && <Paragraph className={classNames('u-bottom-margin--md')}>{text}</Paragraph>}

			<Paragraph className={classNames('u-bottom-margin--md')}>
				<strong>Name</strong>
				<br />
				{name}
			</Paragraph>
			<Paragraph className={classNames('u-bottom-margin--lg')}>
				<strong>Email</strong>
				<br />
				{email}
			</Paragraph>
			<Form onSubmit={handleSubmit(onSubmit, onError)} errorSummary={errorSummary} errorSummaryPosition="bottom">
				<FormfieldString
					id="password"
					name="password"
					label={dictionary.getValue('Form.ChoosePassword', null, 'Choose your password')}
					type="password"
					className={classNames(styles.Login_Formfield, 'u-bottom-margin--lg')}
					state={
						errors.password
							? {
									hasError: true,
									required: true,
							  }
							: { required: true }
					}
					errorMessage={errors.password?.message}
					placeholder="12+ characters"
					// pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
					register={register}
					rules={{
						required: {
							value: true,
							message: 'This field is required',
						},
						minLength: {
							value: 12,
							message: 'Password must have at least 12 characters',
						},
					}}
				/>

				<FormfieldString
					id="confirmPassword"
					name="confirmPassword"
					label={dictionary.getValue('Form.ConfirmPassword', null, 'Confirm your password')}
					type="password"
					className={classNames(styles.Login_Formfield, 'u-bottom-margin--lg')}
					state={
						errors.confirmPassword
							? {
									hasError: true,
									required: true,
							  }
							: { required: true }
					}
					errorMessage={errors.confirmPassword?.message}
					placeholder="Same as above"
					// pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
					register={register}
					rules={{
						required: {
							value: true,
							message: 'This field is required',
						},
						validate: {
							match: (value) => value === watch('password') || 'The passwords do not match',
						},
					}}
				/>

				<Button
					className={classNames(styles.Login_button)}
					style="primary"
					type="submit"
					aria-label={dictionary.getValue('Form.CreateAccount', null, 'Create Account')}
				>
					{dictionary.getValue('Form.CreateAccount', null, 'Create Account')}
				</Button>
			</Form>
		</LoginBox>
	);
};
